import React, { useState } from 'react';

// ✅ IMPORT IMAGES
import sinazo from '../assets/Sinazo_Vuzane2.jpg';
import jacobus from '../assets/Jacobus_Mudau2.jpg';
import lebogang from '../assets/Lebogang_Selao2.jpg';
import joseph from '../assets/Joseph_Mohomi2.jpg';
import mphile from '../assets/Mphile_Dlamini2.jpg';
import team7 from '../assets/team7.jpeg';
import team8 from '../assets/team8.jpeg';
import opsTeam from '../assets/lociware-ops-team.jpg';

export default function TeamMembers() {
  const [showMore, setShowMore] = useState(false);

  const handleToggle = () => {
    setShowMore((prev) => !prev);
  };

  return (
    <section className="team-members">
      <h2 className="team-title">OUR TEAM MEMBERS</h2>
      <p className="team-description">Your Safety Is Our Top Priority</p>

      <div className="team-cards">
        <div className="team-card">
          <img src={sinazo} alt="Team Member 1" className="team-image" />
          <h3>SINAZO VUZANE</h3>
          <p>General Manager</p>
        </div>
        <div className="team-card">
          <img src={jacobus} alt="Team Member 2" className="team-image" />
          <h3>JACOBUS MUDAU</h3>
          <p>Operations Manager</p>
        </div>
        <div className="team-card">
          <img src={lebogang} alt="Team Member 3" className="team-image" />
          <h3>LEBOGANG SELAO</h3>
          <p>HSSE Manager</p>
        </div>
      </div>

      {showMore && (
        <div className="team-cards more-team">
          <div className="team-card">
            <img src={joseph} alt="Team Member 4" className="team-image" />
            <h3>JOSEPH MOHOMI</h3>
            <p>Accounts Manager</p>
          </div>
          <div className="team-card">
            <img src={mphile} alt="Team Member 6" className="team-image" />
            <h3>MPHILE DLAMINI</h3>
            <p>Office Admin</p>
          </div>
          <div className="team-card">
            <img src={team7} alt="Team Member 5" className="team-image" />
            <h3>NTSEWA PHUTHI</h3>
            <p>Ops Controller</p>
          </div>

          
          <div className="team-card">
            <img src={team8} alt="Team Member 8" className="team-image" />
            <h3>ROLIVHUWA MULEYA</h3>
            <p>Finance manager</p>
          </div>
          <div className="team-card">
            <img src={opsTeam} alt="Team Member 9" className="team-image" />
            <h3>Operational Team</h3>
            <p>Team</p>
          </div>
        </div>
      )}

      <button className="team-button" onClick={handleToggle}>
        {showMore ? "Show Less" : "Meet the Rest of the Team"}
      </button>

      <p className="team-message">
        At Lociware, we pride ourselves in delivering extensive services to fulfill all of your needs with first-rate customer care.  
        By offering exceptional service with meticulous attention to detail, we have developed into a leading and trusted provider of ground transportation in South Africa.  
        Our goal is to make your travels safe, effortless, and always on schedule.
      </p>
    </section>
  );
}